import React, { useEffect, useState } from 'react';
import AuthActions from "../redux/auth/actions"

const InactivityLogout = () => {
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  // Logout user if inactive for 15 minutes
  const handleLogout = () => {
    // console.log('User logged out due to inactivity');
    setIsLoggedOut(true);
    sessionStorage.removeItem('biller_access')
    localStorage.removeItem('module_access_biller')
    window.location.replace(`${window.location.origin}/login`)
  };

  // Update last activity timestamp
  const updateActivity = () => {
    setLastActivity(Date.now());
  };

  useEffect(() => {
    const checkInactivity = () => {
      const currentTime = Date.now();
      if (currentTime - lastActivity > 900000) { // 15 minutes in milliseconds
        handleLogout();
      }
    };

    // Set an interval to check for inactivity every minute
    const intervalId = setInterval(checkInactivity, 60000);

    // Event listeners for activity tracking
    const activityEvents = ['mousemove', 'mousedown', 'keydown', 'touchstart'];
    activityEvents.forEach(event =>
      document.addEventListener(event, updateActivity)
    );

    // Clean up the event listeners and interval when component unmounts
    return () => {
      clearInterval(intervalId);
      activityEvents.forEach(event =>
        document.removeEventListener(event, updateActivity)
      );
    };
  }, [lastActivity]); // Rerun the effect if lastActivity changes

  if (isLoggedOut) {
    return <div>You have been logged out due to inactivity.</div>;
  }

  return <></>;
};

export default InactivityLogout;
